import CampusAttendance from '@/api/campus-attendance'
import ClassOperation from '@/api/class-operation'
import StudentProfile from '@/api/student-profile'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return CampusAttendance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  fetchClasses (context) {
    return ClassOperation.get({
      params: {
        page: -1,
        include: 'teacher,academic_study_time',
        fields: {
          academic_classes: 'class_id,class_name,teacher_resp_id,ac_st_id'
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchStudents (context, attributes = {}) {
    return StudentProfile.get({
      params: {
        page: -1,
        fields: {
          setup_student_profiles:
            'student_id,first_name_kh,last_name_kh,first_name_en,last_name_en'
        },
        filter: {
          student_in_class: attributes.class_id
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  // Export Excel
  exportExcel (context, data) {
    return CampusAttendance.exportExcel(data)
  },
  store (context, data) {
    return CampusAttendance.store(data)
  }
}
